
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { useState, Fragment } from 'react';
import {
  FormGroup,
  Label,
  Input,
  Checkbox,
  Margin,
  Flex,
  FlexItem,
  FlexJustify,
  InputGroup,
  Size,
  Toggle,
  Separator,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
export const PlaceholderExample = () => {
  const [isPlaceholder, setIsPlaceholder] = useState(false);
  return <Fragment mdxType="Fragment">
      <Margin size={{
      bottom: Size.DEFAULT
    }} mdxType="Margin">
        <Toggle value={isPlaceholder} onChange={setIsPlaceholder} mdxType="Toggle" />
      </Margin>
      <Margin size={{
      bottom: Size.DEFAULT
    }} mdxType="Margin">
        <Separator mdxType="Separator" />
      </Margin>
      <Flex mdxType="Flex">
        <FlexItem flex mdxType="FlexItem">
          <Margin size={{
          right: Size.SMALL
        }} mdxType="Margin">
            <FormGroup input={<Input isPlaceholder={isPlaceholder} placeholder="Something..." value="" onChange={x => x} mdxType="Input" />} label={<Label isPlaceholder={isPlaceholder} mdxType="Label">My input label</Label>} mdxType="FormGroup" />
          </Margin>
        </FlexItem>
        <FlexItem flex mdxType="FlexItem">
          <FormGroup input={<Input isPlaceholder={isPlaceholder} placeholder="Something..." value="" onChange={x => x} mdxType="Input" />} label={<Label isPlaceholder={isPlaceholder} mdxType="Label">My input label</Label>} mdxType="FormGroup" />
        </FlexItem>
      </Flex>
      <Margin size={{
      vertical: Size.SMALL
    }} mdxType="Margin">
        <Input isPlaceholder={isPlaceholder} placeholder="Something..." value="" onChange={x => x} mdxType="Input" />
      </Margin>
      <Checkbox isPlaceholder={isPlaceholder} mdxType="Checkbox">
        This is a checkbox with a label
      </Checkbox>
    </Fragment>;
};

const layoutProps = {
  PlaceholderExample
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Forms`}</h1>

<h4>{`isPlaceholder example`}</h4>
<p>{`Click the switch to enable or disable the placeholder state of the components. This is a field available on some components in the system as `}<inlineCode parentName="p">{`isPlaceholder`}</inlineCode>{`.`}</p>
<Playground __position={0} __code={`<PlaceholderExample />`} mdxType="Playground">
  <PlaceholderExample mdxType="PlaceholderExample" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;